<template>
  <div class="createOrder_box">
    <div class="page_title">
      <custom-breadcrumb :suffix="`Order NO. ${orderId}}`"/>
    </div>
    <p class="con_title">Customer</p>
    <div class="order_search">
      <div>
        <div
          class="search_content flex"
        >
          <div class="con_left">
            <p class="con_title">Customer</p>
            <p class="user_info">
              Username: <span class="info_text">{{ userInfo.userName }}</span>
            </p>
            <p class="user_info">
              Email: <span class="info_text">{{ userInfo.email }}</span>
            </p>
            <p class="user_info">
              Phone: <span class="info_text">{{ userInfo.phone }}</span>
            </p>
            <p class="user_info">
              Store name: <span class="info_text">{{ userInfo.storeName }}</span>
            </p>
          </div>
          <div class="con_right">
            <p class="con_title">
              Ship Total
              <span @click="openAddress">
                <img src="@/assets/img/memo.png" alt="">
              </span>
              </p>
              <div>
                <p class="user_info"  v-if="tsStoreOrderAddress.addressFirstName&&tsStoreOrderAddress.addressLastName">{{ tsStoreOrderAddress.addressFirstName}}&nbsp;&nbsp;{{ tsStoreOrderAddress.addressLastName}}<br/></p>
                <p class="user_info"  v-if="tsStoreOrderAddress.address">{{ tsStoreOrderAddress.address }}<br/></p>
                <p class="user_info" v-if="tsStoreOrderAddress.address&&tsStoreOrderAddress.city&&tsStoreOrderAddress.province &&tsStoreOrderAddress.postCode && tsStoreOrderAddress.countryName" >
                  {{ tsStoreOrderAddress.city}}, {{ tsStoreOrderAddress.province }}, {{ tsStoreOrderAddress.countryName }}, {{ tsStoreOrderAddress.postCode }}
                </p>
                <p class="user_info" v-if="tsStoreOrderAddress.phone">{{tsStoreOrderAddress.areaCode}}-{{ tsStoreOrderAddress.phone}}</p>
              </div>
          </div>
        </div>
      </div>
    </div>
    <p class="con_title">Order details</p>
    <div class="creat_order">
      <el-table :data="tsStoreOrderDetailList" border style="width: 100%">
        <el-table-column prop="date" label="Item" width="640">
          <template slot-scope="scope">
            <div class="prduct_box">
              <img class="product_img" :src="scope.row.skuImg" alt="" />
              <div class="product_info">
                <p class="product_name">
                  {{ scope.row.skuName }}
                </p>
                <p class="product_size">{{scope.row.skuParam1}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Wholesale Price" width="180">
          <template slot-scope="scope">
            <div class="prduct_box flex_all">
              <el-input
                class="price_input"
                v-model="scope.row.unitPrice"
                placeholder="wholesalePrice"
                @change="countAllTotalPrice(scope.$index,scope.row.unitPrice,scope.row.unitPriceBeforeDiscount)"
              />
              <div :class="scope.row.deleteLine || scope.row.unitPrice !=scope.row.unitPriceBeforeDiscount ?'dis_price dis_line':'dis_price'">${{ scope.row.unitPriceBeforeDiscount }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="Qty">
          <template slot-scope="scope">
            <div class="prduct_box flex_all qty-left">
              <el-input
                class="price_input"
                v-model="scope.row.num"
                placeholder="Qty"
                @change="countAllTotalChange(scope.$index,scope.row.num)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="Total">
          <template slot-scope="scope">
            <div class="flex total_amount">
              <span>${{ scope.row.commodityAmount }}</span>
              <span class="order-delete" @click="deleteOrder(scope.row)"><i class="el-icon-close"></i></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="product-bottom">
    <div class="product-bottom-memo">
       <div>
          <div class="memo-text">Memo</div>
          <div>
            <el-input
              type="textarea"
              rows="8"
              placeholder="Fill out Memo"
              maxlength="500"
              show-word-limit
              v-model="tsStoreOrderInfo.memo"
              @keydown.native="memoChange($event)"
            >
            </el-input>
          </div>
      </div>
    </div>
    <div class="product-bottom-price">
      <div class="end_box flex" v-if="orderDetails">
      <div class="creat_text flex">
        <p>Total quantity</p>
        <p>{{ tsStoreOrderInfo.goodsNum }}</p>
      </div>
      <div class="creat_text flex">
        <p>Total price of goods</p>
        <p>${{ tsStoreOrderInfo.totalPriceBefore }}</p>
      </div>
      <div class="creat_text flex">
        <p class="brown_text">Product discount</p>
        <p class="brown_text">
          <span class="black_text">-</span>${{ tsStoreOrderInfo.productDiscounted }}
        </p>
      </div>
      <div class="creat_text flex">
        <p class="brown_text">Supplier order discount</p>
        <div>
          - <span class="brown_text">$</span>
          <el-input
            class="price_input brown_text"
            v-model="tsStoreOrderInfo.orderDiscounted"
            placeholder=""
            clearable
            @change="changePrice"
          />
        </div>
      </div>
      <!-- <div class="creat_text flex">
        <p>Shipping</p>
        <p>${{ shippingPrice }}</p>
      </div> -->
      <div class="creat_text flex">
        <p class="">Shipping fee</p>
        <div style="margin-top:10px">
          <span class="">$</span>
          <el-input
            :disabled="disabled"
            class="price_input"
            v-model="tsStoreOrderInfo.totalFreight"
            @change="changeShipping"
            placeholder=""
            clearable
          />
        </div>
      </div>
      <div class="creat_text blod_text flex">
        <p>Total Amount</p>
        <p>{{ tsStoreOrderInfo.payAmount }}</p>
      </div>
      <el-button type="primary" class="add-btn" @click="editOrder()"
        >Submit</el-button
      >
    </div>
    </div>
    </div>
    <el-dialog
      :visible.sync="successVisible"
      :close-on-click-modal="false"
      width="30%"
      @close="backOrderList()"
    >
      <span class="back_icon" @click="backOrderList()"><i class="el-icon-arrow-left"></i>Back</span>
      <p class="success_text">Order modified successfully</p>
      <div class="flex_all">
        <el-button
          type="primary"
          class="back_button"
          @click="backOrderList()"
          >Back Order List ({{seconds}})</el-button
        >
      </div>
    </el-dialog>
    <div>
      <Address ref="address" :addressMessage="addressMessage"  />
    </div>
  </div>
</template>

<script>
import { postAction, getAction, putAction } from '@/api/manage.js'
import Address from '@/pages/components/address.vue'
import { val } from 'dom7'
import CustomBreadcrumb from '../components/custom-breadcrumb'
export default {
  components: {
    Address,CustomBreadcrumb
  },
  data() {
    return {
      orderId: '',
      userInfo: '',
      timer: '',
      tsStoreOrderInfo: '',
      tsStoreOrderDetailList: [],
      tsStoreOrderAddress: '',
      removeOrderDetailIds: [],
      seconds: 5,
      totalPrice: '',
      memo: '', // memo绑定值
      addressId: '', // 地址id
      addressType: false, // 弹窗
      deleteLine: false,
      allProductQty: 0,
      successVisible: false,
      skuEdit: true,
      searchWords: '',
      searchSpuWords: '',
      dialogVisible: false,
      retailerInfo: [],
      reInfo: {},
      activeNames: ['1'],
      wholesalePrice: '',
      itemTotel: 0,
      wholesaleNum: '',
      orderDiscount: 0,
      shippingDiscount: 0,
      totalPriceOfGoods: 0,
      goodsDiscount: 0,
      shippingPrice: 0,
      totalAmount: 0,
      orderDetails: [],
      checkAllSpuIdArr: [],
      checkedCities: [],
      isIndeterminate: true,
      allProduct: [],
      createOrderId: '',
      // 所有的spu和sku
      spuWithSkuArrMap: new Map(),
      addressMessage: {},
      disabled: false
    }
  },
  created() {
    this.orderId = this.$route.query.orderId
    this.loadRetailerInfo()
  },
  beforeDestroy () {
    console.log('清除定时器')
    clearTimeout(this.timer)
  },
  methods: {
    editOrder() {
      let params = {
        'tsStoreOrderInfo': this.tsStoreOrderInfo,
        'tsStoreOrderDetailList': this.tsStoreOrderDetailList,
        'removeOrderDetailIds': this.removeOrderDetailIds,
        'tsStoreOrderAddress': this.tsStoreOrderAddress
      }
      putAction(`/sp/suppliers/retailers/orders/${this.orderId}`, params).then((res) => {
        if (res.success) {
          console.log(res, '提交修改')
          this.successVisible = true
          this.countdown()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    countdown() {
      if (this.seconds === 0) {
        this.backOrderList()
      } else {
        this.seconds--
        this.timer = setTimeout(this.countdown, 1000)
      }
    },
    backOrderList() {
      clearTimeout(this.timer)
      this.successVisible = false
      this.$router.push({ path: 'Order' })
    },
    memoChange(e) {
      if (e.keyCode === 13) { e.returnValue = false }
    },
    openAddress() {
      this.addressMessage = {
        addressId: this.tsStoreOrderAddress.addressId,
        userId: this.userInfo.id,
        type: 'ordeEdit'
      }
      this.$refs.address.dialogVisible = true
    },

    toOrders() {
      this.$router.push({ path: 'Order' })
    },
    toOrderDetails() {
      this.$router.push({path: 'OrderDetail', query: {orderId: this.orderId}})
    },
    countAllTotalChange(idx, val) {
      const reg = /^([0-9]|[1-9]\d+)(\.\d{0})?$/
      if (reg.test(val)) {
        if (val < 1) {
          this.tsStoreOrderDetailList[idx].num = 1
        }
      } else {
        this.tsStoreOrderDetailList[idx].num = 1
      }
      this.tsStoreOrderInfo.orderDiscounted = 0
      this.tsStoreOrderInfo.totalFreight = 0
      this.tsStoreOrderDetailList[idx].commodityAmount = (this.tsStoreOrderDetailList[idx].unitPrice * this.tsStoreOrderDetailList[idx].num).toFixed(2)
      this.countAllTotal()
    },
    async countAllTotalPrice(idx, newPrice, oldPrice) {
      const reg = /^([0-9]|[1-9]\d+)(\.\d{1,2})?$/
      if (reg.test(newPrice)) {
        if (newPrice > oldPrice) {
          this.tsStoreOrderDetailList[idx].unitPrice = this.tsStoreOrderDetailList[idx].unitPriceBeforeDiscount
        }
      } else {
        this.tsStoreOrderDetailList[idx].unitPrice = this.tsStoreOrderDetailList[idx].unitPriceBeforeDiscount
      }
      this.tsStoreOrderInfo.orderDiscounted = 0
      this.tsStoreOrderDetailList[idx].commodityAmount = (this.tsStoreOrderDetailList[idx].unitPrice * this.tsStoreOrderDetailList[idx].num).toFixed(2)
      await this.countAllTotal()
    },
    // 计算订单创建前所有价格
    countAllTotal() {
      this.tsStoreOrderInfo.totalPriceBefore = 0
      this.tsStoreOrderInfo.productDiscounted = 0
      this.tsStoreOrderInfo.goodsNum = 0
      this.tsStoreOrderDetailList.forEach((newsku) => {
        this.tsStoreOrderInfo.totalPriceBefore += Number(newsku.unitPriceBeforeDiscount) * Number(newsku.num)
        this.tsStoreOrderInfo.productDiscounted += (Number(newsku.unitPriceBeforeDiscount) * Number(newsku.num)) - (Number(newsku.unitPrice) * Number(newsku.num))
        this.tsStoreOrderInfo.goodsNum += Number(newsku.num)
        if (newsku.unitPrice && newsku.unitPrice < newsku.unitPriceBeforeDiscount) {
          newsku.deleteLine = true
        } else {
          newsku.deleteLine = false
        }
      })
      this.tsStoreOrderInfo.totalPriceBefore = this.tsStoreOrderInfo.totalPriceBefore.toFixed(2)
      this.tsStoreOrderInfo.productDiscounted = this.tsStoreOrderInfo.productDiscounted.toFixed(2)
      this.tsStoreOrderInfo.payAmount = Math.abs(Number(this.tsStoreOrderInfo.totalPriceBefore) + Number(this.tsStoreOrderInfo.totalFreight) - (Number(this.tsStoreOrderInfo.productDiscounted) + Number(this.tsStoreOrderInfo.orderDiscounted))).toFixed(2)
    },
    loadRetailerInfo() {
      getAction('/sp/suppliers/retailers/orders/' + this.orderId).then(
        (res) => {
          if (res.success) {
            this.tsStoreOrderInfo = res.result.tsStoreOrderInfo
            this.tsStoreOrderDetailList = res.result.tsStoreOrderDetailList
            this.tsStoreOrderAddress = res.result.tsStoreOrderAddress
            this.userInfo = res.result.userInfo
            if (this.tsStoreOrderInfo) {
              getAction('/sp/suppliers/own-brand').then(
                (res) => {
                  if (res.success) {
                    if (res.result) {
                      if (this.tsStoreOrderInfo.logisticUnderwriter && res.result.model !== 4) {
                        this.disabled = true
                      }
                    }
                  } else {
                    this.$message.warning(res.message)
                  }
                }
              )
            }
          } else {
            this.$message.warning(res.message)
          }
        }
      )
    },
    deleteOrder(data) {
      if (this.tsStoreOrderDetailList.length == 1) {
        this.$message.warning('There is only 1 item in the order and cannot be deleted')
        return
      }
      this.tsStoreOrderDetailList.map((e, i) => {
        if (e.skuCode === data.skuCode) {
          this.removeOrderDetailIds.push(e.uid)
          this.tsStoreOrderDetailList.splice(i, 1)
          this.tsStoreOrderInfo.orderDiscounted = 0
          this.tsStoreOrderInfo.totalFreight = 0
          this.countAllTotal()
        }
      })
      console.log(this.tsStoreOrderDetailList, '订单信息')
    },
    changePrice(value) {
      const reg = /^([0-9]|[1-9]\d+)(\.\d{1,2})?$/
      if (reg.test(value)) {
        if (Number(value) > (Number(this.tsStoreOrderInfo.totalPriceBefore) - Number(this.tsStoreOrderInfo.productDiscounted)).toFixed(2)) {
          this.tsStoreOrderInfo.orderDiscounted = 0
        } else {
          this.tsStoreOrderInfo.orderDiscounted = value
        }
      } else {
        this.tsStoreOrderInfo.orderDiscounted = 0
      }
      this.countAllTotal()
    },
    changeShipping(value) {
      const reg = /^([0-9]|[1-9]\d+)(\.\d{1,2})?$/
      if (reg.test(value)) {
        // if (Number(value) > Number(this.shippingPrice)) {
        //   this.shippingDiscount = 0
        // } else {
        this.tsStoreOrderInfo.totalFreight = value
        // }
      } else {
        this.tsStoreOrderInfo.totalFreight = 0
      }
      this.countAllTotal()
    }
  }
}
</script>

<style scoped lang="less">
.order_num{
    margin-left: 30px;
  }
.total_amount{
  justify-content: space-between;
  padding-right: 10px;
}
/deep/ .el-select .el-input__inner{
  width: 380px !important;
  margin-left: 16px;
}
.el-select-dropdown__item{
  height: 60px !important;
  line-height: 26px !important;
}
.checkout_style {
  // margin-left: 30px;
  flex-direction: column;
}
/deep/.el-collapse {
  border: none;
}
/deep/.el-collapse-item__wrap {
  border-bottom: none !important;
}
/deep/.checkout_style .el-checkbox {
  padding-left: 30px;
  width: 96%;
}
/deep/.el-checkbox {
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: #e1e1e1 solid 1px;
}
/deep/.el-input--suffix .el-input__inner {
  padding-right: 10px !important;
}
/deep/.el-tree-node__content {
  height: 80px;
}
/deep/.el-checkbox__inner {
  border-color: #262b2f !important;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner {
  background: #262b2f !important;
  border-color: #262b2f !important;
}
/deep/.brown_text .el-input__inner {
  color: #c3824b;
}
/deep/.el-button--primary {
  width: 90px;
  height: 40px;
  background: #262b2f;
  border: none;
  border-radius: 3px;
}
.gery_color {
  color: #8f8f8f;
  cursor: pointer;
}
.order_search {
  width: 95%;
  height: auto;
  border: 1px solid #e1e1e1;
  margin: 0 0 20px 25px;
  padding: 14px 0;
}
.con_title {
  margin-bottom: 15px;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 500;
  color: #262b2f;
  margin-left: 30px;
}
.search_input2 {
  width: 40%;
  margin-left: 30px;
}
.creat_order {
  width: 95%;
  margin-left: 30px;
}
.prduct_box {
  display: flex;
  .product_img {
    width: 80px;
    height: 80px;
    border: 1px solid #e1e1e1;
  }
  .product_info {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    line-height: 20px;
    color: #262b2f;
    padding: 12px 0 0 12px;
  }
  .dis_price {
    margin-left: 10px;
  }
  .dis_line{
    text-decoration:line-through;
  }
}
.price_input {
  width: 80px;
  height: 40px;
}
.black_text {
  color: #262b2f;
  margin-right: 3px;
}
.brown_text {
  color: #c3824b;
}
.add-btn {
  background-color: #262b2f;
  border-color: #262b2f;
  width: 192px;
  height: 38px;
  border-radius: 3px;
  margin-top: 20px;
  cursor: pointer;
}
.end_box {
  width: 90%;
  margin-left: 30px;
  padding-bottom: 50px;
  flex-direction: column;
  align-items: flex-end;
  .creat_text {
    width: 50%;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
  }
  .blod_text {
    font-size: 16px;
    font-family: Graphik;
    font-weight: 500;
    color: #262b2f;
  }
}
.search_content {
  padding-top: 10px;
  .con_left {
    width: 32%;
  }
  .user_info {
    margin-left: 30px;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    line-height: 18px;
    color: #5d5d5d;
    .info_text {
      color: #262b2f;
    }
  }
}
.dialog_title {
  padding-top: 20px;
}
.sku_img {
  width: 60px;
  height: 60px;
  border: 1px solid #e1e1e1;
}
.dialog_box {
  max-height: 500px;
  overflow: scroll;
}
.custom-tree-node {
  width: 100%;
  .spu_title {
    width: 600px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 10px;
  }
  .sku_name {
    margin: 10px 0 0 10px;
  }

  .dialog-footer {
    position: fixed;
    bottom: 0;
    left: 0;
  }
}
.sku_size {
  width: 700px;
  height: 40px;
  padding: 0 40px 0 10px;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 20px;
  color: #262b2f;
  // border-bottom: #e1e1e1 solid 1px;
  span {
    margin-left: 10px;
  }
}
.all_select_num {
  position: absolute;
  bottom: 30px;
  left: 20px;
  color: #262b2f;
}
.back_icon {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  line-height: 40px;
  color: #262b2f;
  margin: 0 0 0 10px;
  cursor: pointer;
}
.success_text {
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 18px;
  color: #262b2f;
  text-align: center;
  margin-top: 10px;
}
.back_button {
  width: 164px;
  height: 41px;
  border: 1px solid #707070;
  border-radius: 3px;
  margin: 30px 0;
}
.re_text{
  flex-direction: column;
  height: 40px;
  .span_margin{
    padding: 0 2px;
  }
}
.more_text{
  margin: 10px 0;
  text-align: center;
}
.order-delete{
  cursor: pointer;
  padding-left: 10px;
  font-size: 16px;
}
.qty-left{
  display: flex;
  justify-content: left;
}
.product-bottom{
  display: flex;
  justify-content: space-between;
  .product-bottom-memo{
    padding-left: 25px;
    padding-top: 21px;
    width: 657px;
    height: 161px;
    .memo-text{
      padding-bottom: 19px;
    }
  }
  .product-bottom-price{
    width: 800px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/editOrder.vue